import React from "react";
import { Box, Button, Heading } from "@chakra-ui/react";
import NavBar from "../Components/Navbar";

function ButtonPage() {
  const handleClick = async () => {
    try {
      const response = await fetch("https://us-central1-jpf-prd-py.cloudfunctions.net/university-report-generation");
      if (!response.ok) {
        throw new Error("Failed to trigger function");
      }
      alert("Function triggered successfully!");
    } catch (error) {
      console.error("Error:", error);
      alert("Error triggering function.");
    }
  };

  return (
    <>
      <NavBar activeName="Button" />
      <Box m={6}>
        <Heading mb={4}>This is the Button Page</Heading>
        <Button colorScheme="teal" onClick={handleClick}>
          Trigger Report
        </Button>
      </Box>
    </>
  );
}

export default ButtonPage;
